import flags from './feature-flags';

const Features = Object.keys(flags).map((feature) => ({ name: feature, isActive: flags[feature] }));

export default Features;
